<style lang="scss" scoped>
.content-item {
  border: 1px solid #f4f5f9;
  .content-item__title {
    background: #f4f5f9;
    padding: 10px 20px;
  }
  .content-item_info {
    padding: 25px 0;
  }
  .content-item__echarts {
    height: 450px;
    // height: 400px;
  }
}
</style>

<template>
  <div class="content">
    <div class="content-item MB-20">
      <div class="content-item__title flex-row-between">
        <div class="content-item__title-left flex-row-start">
          <el-date-picker
            v-model="date"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            :clearable="false"
            @change="refreshPageDate"
            size="small"
          ></el-date-picker>

          <el-select
            v-model="origin"
            class="ML-20"
            placeholder="请选择来源"
            clearable
            @change="platformChange"
            size="small"
          >
            <el-option v-for="item in origins" :key="item" :label="item" :value="item"></el-option>
          </el-select>

           <el-select
            v-model="channel"
            class="ML-20"
            multiple
            collapse-tags
            placeholder="请选择频道"
            :disabled="true"
            size="small"
          >
            <el-option v-for="item in channels" :key="item" :label="item" :value="item"></el-option>
          </el-select>

           <el-select
            v-model="citySite"
            placeholder="请选择站点"
            clearable
            @change="refreshPageDate"
            size="small"
            class="ML-20"
          >
            <el-option v-for="item in citySites" :key="item._id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </div>
        <div class="content-item__title-right text-14 pointer text-blue" @click="downloadExcel">下载报表</div>
      </div>
      <div class="content-item_info flex-row-start text-16">
        <div class="content-item__info-item flex-w__1 text-center">
          <p>访问量（IP）</p>
          <div class="text-18 text-bold MT-20">{{dataSet.ip || 0}}</div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>浏览量（PV）</p>
          <div class="text-18 text-bold MT-20">{{dataSet.pv || 0}}</div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>访客数（UV）</p>
          <div class="text-18 text-bold MT-20">{{dataSet.uv || 0}}</div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>访问次数（VV）</p>
          <div class="text-18 text-bold MT-20">{{dataSet.vv || 0}}</div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>平均访问页数</p>
          <div class="text-18 text-bold MT-20">{{dataSet.per_user_view || 0}}</div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>新访客数</p>
          <div class="text-18 text-bold MT-20">{{dataSet.new_user || 0}}</div>
        </div>
        <div class="content-item__info-item flex-w__1 text-center">
          <p>平均访问时长</p>
          <div class="text-18 text-bold MT-20">{{formatDuring(dataSet.time_avg)}}</div>
        </div>
        <!-- <div class="content-item__info-item flex-w__1 text-center">
                    <p>跳出率</p>
                    <div class="text-20 text-bold MT-20">{{0}}</div>
        </div> -->
      </div>
    </div>

    <div class="content-item">
      <div class="content-item__title flex-row-between">
        <div class="content-item__title-left flex-row-start">
          <el-select
            v-model="activeType"
            class="MR-20"
            placeholder="请选择数据类型"
            @change="getContentData"
            size="small"
          >
            <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="content-item_info content-item__echarts flex-row-start" ref="echarts"></div>
    </div>

    <el-table border :data="tableData" id="table" size="small" header-row-class-name="table-header">
      <el-table-column align="center" label="时段/日段" prop="time"></el-table-column>
      <el-table-column align="center" label="访问量IP" prop="ip"></el-table-column>
      <el-table-column align="center" label="页面浏览量PV" prop="pv"></el-table-column>
      <el-table-column align="center" label="访客数UV" prop="uv"></el-table-column>
      <el-table-column align="center" label="平均访问时长" prop="ta"></el-table-column>
      <!-- <el-table-column
                align="center"
                label="跳出率"
                prop="time">

      </el-table-column>-->
    </el-table>
  </div>
</template>

<script>
const end = new Date();
const start = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
const startTime = getYear(start);
const endTime = getYear(end);

/**
 * 返回格式化的时间
 * @param {Date} date 当前需要格式化的时间对象
 * @param {Boolean} isTime 是否显示时分秒
 * @param {Boolean} onlyTime 是否仅仅只显示时分秒
 */
function getYear(date, isTime, onlyTime) {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let time = year + "-" + get0(month) + "-" + get0(day);
  if (isTime) {
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    if (onlyTime) {
      time = get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
    } else {
      time += " " + get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
    }
  }

  return time;
}
function get0(num) {
  return num < 10 ? "0" + num : num;
}

import Echarts from "echarts";
import FileSaver from "file-saver";
import XLSX from "xlsx";

import {channel} from "../../../plugins/dictionary.js";
export default {
  data() {
    return {
      dataSet: {},
      // 表格数据
      tableData: [],
      // 选中时间
      date: [startTime, endTime],
      // 当前选中来源
      origin: "",
      // 可选来源列表
      origins: [],
      // 当前选中频道
      channel: [],
      // 可选频道列表
      channels: [],
      // 当前选中筛选类型
      activeType: "ip",
      // 当前选中站点
      citySite:"",
      // 可选站点列表
      citySites:[],
      // 筛选类型
      types: [
        {
          id: "ip",
          name: "访问量（IP）"
        },
        {
          id: "pv",
          name: "浏览量（PV）"
        },
        {
          id: "uv",
          name: "访客数（UV）"
        },
        {
          id: "vv",
          name: "访问次数（VV）"
        },
        {
          id: "nu",
          name: "新房客数"
        }
      ],
      // 时间选择器配置
      pickerOptions: {
        shortcuts: [
          {
            text: "不限",
            onClick(picker) {
              picker.$emit("pick", ["", ""]);
            }
          },
          {
            text: "一天内",
            onClick(picker) {
              const start = new Date();
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "七天内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "30天内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "一年内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    /**
     * 返回当前数据获取类型
     */
    getTimeType() {
      if (this.date[0] && this.date[0] === this.date[1]) {
        return "hour";
      }
      return "day";
    }
  },
  created() {
    let channelText = this.$route.params.channel.replace(/(\s*$)/g, "");
    if(channel[channelText]){
      this.channel.push(channel[channelText])
    }else{
      return
    }
    const Loading = this.$loading();
    Promise.all([
      this.getPlatform(false),
      this.getCountAll(false),
      this.getContentData(false),
      this.getTableData(false),
      this.getCitySite(false)
    ])
      .then(res => {
        this.origins = res[0].data;
      })
      .finally(() => {
        Loading.close();
      });
  },
  methods: {
    /**
     * 毫秒转换成分/秒
     */
    formatDuring(mss) {
      mss = Number(mss);
      if (isNaN(mss)) {
        return 0;
      }
      var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (mss % (1000 * 60)) / 1000;
      return get0(minutes) + ":" + get0(Math.round(seconds));
    },
    /**
     * 下载报表
     */
    downloadExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#table"));
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "流量趋势分析.xlsx"
        );
      } catch (e) {
        this.$message.error("文件下载失败");
      }
      return wbout;
    },
    /**
     * 刷新头部数据、折线图、和表格数据
     */
    refreshPageDate() {
      const Loading = this.$loading();
      Promise.all([
        this.getCountAll(false),
        this.getContentData(false),
        this.getTableData(false)
      ]).finally(() => {
        Loading.close();
      });
    },

    /**
     * 初始化echarts
     * @param {Array} x x轴数据
     * @param {Array} y 当前y轴数据
     * @param {Array} y1 前一天y轴数据
     */
    initEcharts(x = [], y = [], y1 = []) {
      let Chart = Echarts.init(this.$refs.echarts);
      let option = {
        xAxis: {
          type: "category",
          data: x
        },
        yAxis: {
          type: "value"
        },
        legend: {
          data: ["当日", "前一日"]
        },
        series: [
          {
            name: "当日",
            data: y,
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#00CCFF"
              }
            },
            lineStyle: {
              normal: {
                color: "#00CCFF"
              }
            },
            label: {
              normal: {
                show: true,
                position: "top",
                color: "#00CCFF"
              }
            }
          },
          {
            name: "前一日",
            data: y1,
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "#FFCC66"
              }
            },
            lineStyle: {
              normal: {
                color: "#FFCC66"
              }
            },
            label: {
              normal: {
                show: true,
                position: "bottom",
                color: "#FFCC66"
              }
            }
          }
        ]
      };
      option.legend.show = y1.length > 0;
      Chart.setOption(option);
      window.onresize = Chart.resize;
    },
    /**
     * 获取表格数据
     */
    getTableData(load = true) {
      let startTime = this.date[0] ? this.date[0] + "T00:00:00.000+0800" : "";
      let endTime = this.date[1] ? this.date[1] + "T23:59:59.999+0800" : "";
      this.$ajax(
        "/web/group_count_all_by_" + this.getTimeType + "",
        Object.assign({
          startTime,
          endTime,
          platform: this.origin,
          channel: this.channel.join(",")
        },this.citySite?{citySite:this.citySite}:{}),
        {
          method: "get",
          load
        }
      ).then(data => {
        let res = data.data;
        let table = [];

        res.ip.forEach((item, index) => {
          let time = new Date(item.name);
          time.setTime(time.getTime() - 3600 * 1000 * 8);
          table.push({
            time: getYear(time, true),
            ip: item.value,
            pv: res.pv[index].value,
            uv: res.uv[index].value,
            ta: this.formatDuring(Math.floor(res.ta[index].value))
          });
        });
        this.tableData = table.reverse();
      });
    },
    /**
     * 获取内容数据
     */
    async getContentData(load = true) {
      let startTime = this.date[0] ? this.date[0] + "T00:00:00.000+0800" : "";
      let endTime = this.date[1] ? this.date[1] + "T23:59:59.999+0800" : "";
      let y1 = [];
      // 如果是一天范围内，则还需要取前一天的数据
      if (this.date[0] && this.date[0] === this.date[1]) {
        let time = new Date(this.date[0]);
        time.setTime(time.getTime() - 3600 * 1000 * 24);
        let date = getYear(time);
        let prevStartTime = date + "T00:00:00.000+0800";
        let prevEndTime = date + "T23:59:59.999+0800";
        let prevDate = await this.$ajax(
          "/web/count_" + this.activeType + "_by_" + this.getTimeType + "",
          Object.assign({
            startTime: prevStartTime,
            endTime: prevEndTime,
            platform: this.origin,
            channel: this.channel.join(",")
          },this.citySite?{citySite:this.citySite}:{}),
          {
            method: "get",
            load
          }
        );
        prevDate.data.forEach(item => {
          y1.push(item.value);
        });
      }
      return this.$ajax(
        "/web/count_" + this.activeType + "_by_" + this.getTimeType + "",
        Object.assign({
          startTime,
          endTime,
          platform: this.origin,
          channel: this.channel.join(","),
        },this.citySite?{citySite:this.citySite}:{}),
        {
          method: "get",
          load
        }
      ).then(data => {
        let res = data.data;
        let x = [];
        let y = [];
        res.forEach(item => {
          let date = new Date(item.name);
          date.setTime(date.getTime() - 3600 * 1000 * 8);
          let time = getYear(
            date,
            this.getTimeType === "hour",
            this.getTimeType === "hour"
          );

          x.push(time);
          y.push(item.value);
        });
        this.initEcharts(x, y, y1);
      });
    },
    /**
     * 获取平台数据
     */
    getPlatform(load = true) {
      return this.$ajax(
        "/web/platform",
        {},
        {
          method: "get",
          load
        }
      );
    },
    /**
     * 获取头部所有数据
     */
    getCountAll(load = true) {
      let startTime = this.date[0] ? this.date[0] + "T00:00:00.000+0800" : "";
      let endTime = this.date[1] ? this.date[1] + "T23:59:59.999+0800" : "";
      return this.$ajax(
        "/web/count_all",
        Object.assign({
          startTime,
          endTime,
          platform: this.origin,
          channel: this.channel.join(",")
        },this.citySite?{citySite:this.citySite}:{}),
        {
          method: "get",
          load
        }
      ).then(data => {
        this.dataSet = data.data;
      });
    },

    /**
     * 平台变化获取频道数据
     * @param {String} platform 当前选中平台
     */
    platformChange() {
      this.refreshPageDate();
    },

    /**
     * 获取站点数据
     */
    getCitySite(load = true) {
      this.$ajax(
        "/web/site",
        {},
        {
          method: "get",
          load
        }
      ).then(data=>{
        this.citySites = data.data
      });
    },

  }
};
</script>